import React, { useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { Feed, NoteInterne } from './comuni';

// Scheda "Note e cronologia" della scheda cliente: lo storico completo (anche le voci interne) con l'iniziale di chi ha
// fatto cosa (il cliente in grigio) e, a destra, tutte le note interne. "+ Azione → Aggiungi una nota" la apre già
// pronta per scrivere.

const TabCronologia = ({ clienteId, note, onFatto, scriviNota = false, versione }) => {
  const [voci, setVoci] = useState(null);
  useEffect(() => { axios.get(`${API}/clienti/${clienteId}/cronologia-staff`).then((r) => setVoci(r.data)).catch(() => setVoci([])); }, [clienteId, versione]);
  return (
    <div className="g2">
      <section className="card r" data-testid="cronologia">
        <div className="ttl"><div className="i"><Icona nome="orologio" /></div><h2>Cronologia completa {voci?.length ? <small>{voci.length}</small> : null}</h2></div>
        {voci ? <Feed voci={voci} vuoto="Ancora niente in cronologia." /> : <p className="vuoto">Carico…</p>}
      </section>
      <div className="stack">
        <NoteInterne key={scriviNota ? 'scrivi' : 'leggi'} clienteId={clienteId} note={note} onFatto={onFatto} aperta={scriviNota} limite={50} />
      </div>
    </div>
  );
};

export default TabCronologia;
